import { render } from "./FtrFootLengthInput.vue?vue&type=template&id=1970e6c3&scoped=true"
import script from "./FtrFootLengthInput.vue?vue&type=script&lang=js"
export * from "./FtrFootLengthInput.vue?vue&type=script&lang=js"

import "./FtrFootLengthInput.vue?vue&type=style&index=0&id=1970e6c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1970e6c3"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QField});
